export default "__VITE_ASSET__a037e68e__"